import { useBreakpointValue } from '@gemini/core';

export type TBreakpoints =
    | 'base'
    | 'extra large'
    | 'extra small'
    | 'large'
    | 'medium'
    | 'small'
    | 'three xl'
    | 'two xl';

export const useBreakpoint = (mobileBreakpoint: TBreakpoints = 'small') => {
    const breakpoint = useBreakpointValue({
        base: 'base',
        xs: 'extra small',
        sm: 'small',
        md: 'medium',
        lg: 'large',
        xl: 'extra large',
        xxl: 'two xl',
        xxxl: 'three xl',
    });

    const breakpoints = [
        'base',
        'extra small',
        'small',
        'medium',
        'large',
        'extra large',
        'two xl',
        'three xl',
    ];

    const isMobileBreakpoints = breakpoints.slice(
        0,
        breakpoints.indexOf(mobileBreakpoint) + 1,
    );

    return {
        isMobile: isMobileBreakpoints.includes(breakpoint),
        isDesktop: !isMobileBreakpoints.includes(breakpoint),
    };
};
